<script>
import { MapAgentStationStatus } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";

export default {
  components: {
    PagenationContainer
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_AGENT =
      localStorage.getItem("roles").indexOf("ROLE_AGENT") > -1 &&
      !(localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1);
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    let tmpSearchForm = {
        name: "",
        agentStationState: "",
        provinceCity: "",
        state: ""
      };
    var s = sessionStorage.getItem("medicalInstitutionSearchForm");
    if (s) {
      tmpSearchForm = JSON.parse(s);
    }

    var tmpPage = 1;
    var p = sessionStorage.getItem("medicalInstitutionAnalysisPage");
    if (p) {
      tmpPage = JSON.parse(p);
    }

    var tmpPrice = 1500;
    var p = localStorage.getItem("coursePrice");
    if (p) {
      tmpPrice = JSON.parse(p);
    }

    return {
      ROLE_SUPER_ADMIN,
      ROLE_AGENT,
      ROLE_REGION_MANAGER,
      distribution: false,
      distributionRefund: false,
      operationGoodsAlert: "一个疗程60次训练，建议每天训练两次",
      salesPromotionFlag: false,
      formInline: {
        organizationId: "",
        organizationName: "",
        status: "",
        county: "",
        city: "",
        province: ""
      },
      ProvinceList: [],
      searchFormData: tmpSearchForm,
      tableData: [],
      addNewReqArr:[
        {label: "购满", keyName: "condition", type: "number", value:""},
        {label: "赠送", keyName: "complimentary", type: "number", value:""}
      ],
      distributeArray: [
        {
          label: "类型",
          keyName: "distributeType",
          type: "select",
          value: 1,
          children: [{label: "疗程", keyName: 1}, {label:"单次训练", keyName: 2}]
        },
        {
          label: "数量",
          keyName: "courseCount",
          type: "number"
        },
        {
          label: "单价",
          keyName: "unitPrice",
          type: "price"
        },
        {
          label: "总价",
          keyName: "totalPrice",
          type: "price",
          isDisable: true
        }],
      agentSearchArray: [
        {
          label: "省市搜索",
          keyName: "provinceCity",
          value: tmpSearchForm.provinceCity,
          children: [],
          type: "cascader"
        },
        {
          label: "机构名称",
          keyName: "name",
          value: tmpSearchForm.name,
          type: "text"
        },
        {
          label: "授权",
          keyName: "agentStationState",
          value: tmpSearchForm.agentStationState,
          type: "select",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "审核中",
              keyName: "APPLYING"
            },
            {
              label: "已核准",
              keyName: "APPROVED"
            },
            {
              label: "已拒绝",
              keyName: "REFUSED"
            }
          ]
        },
      ],
      regionSearchArray: [
        {
          label: "机构名称",
          keyName: "name",
          value: tmpSearchForm.name,
          type: "text"
        },
        {
          label: "授权",
          keyName: "state",
          value: tmpSearchForm.agentStationState,
          type: "select",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "审核中",
              keyName: "PENDING"
            },
            {
              label: "已核准",
              keyName: "REVIEWED"
            }
          ]
        },
        {
          label: "省市搜索",
          keyName: "provinceCity",
          value: tmpSearchForm.provinceCity,
          children: [],
          type: "cascader"
        }
      ],
      adminSearchArray: [
        {
          label: "机构名称",
          keyName: "name",
          value: tmpSearchForm.name,
          type: "text"
        },
        {
          label: "省市搜索",
          keyName: "provinceCity",
          value: tmpSearchForm.provinceCity,
          children: [],
          type: "cascader"
        }
      ],
      addNewStationArr: [
        {
          label: "机构名称",
          keyName: "name",
          type: "text"
        },
        {
          label: "所属省份",
          keyName: "districtProvince",
          type: "select",
          children: []
        },
        {
          label: "所属城市",
          keyName: "districtCity",
          type: "select",
          children: []
        },
        {
          label: "默认售价",
          keyName: "coursePrice",
          type: "number",
          value: tmpPrice
        },
        {
          label: "地址",
          keyName: "location",
          type: "textarea"
        },
        {
          label: "",
          keyName: "duty",
          type: "checkbox",
          children: [
            {
              label: "申请授权",
              keyName: "申请授权",
              checked: true
            }
          ]
        }
      ],
      addingUser: false,
      reviewStation: false,
      rejectStation: false,
      resolveStation: false,
      removeStation: false,
      addingStation: false,
      addNewStationRegion: [
        {
          label: "机构ID",
          keyName: "stationId",
          type: "text"
        },
        {
          label: "机构名称",
          keyName: "name",
          type: "text"
        },
        {
          label: "所属省份",
          keyName: "districtProvince",
          type: "select",
          children: []
        },
        {
          label: "所属城市",
          keyName: "districtCity",
          type: "select",
          children: []
        },
        {
          label: "默认售价",
          keyName: "coursePrice",
          type: "number",
          value: 1500
        },
        {
          label: "地址",
          keyName: "location",
          type: "textarea"
        },
        {
          label: "代理商",
          keyName: "agentId",
          type: "select",
          children: []
        }
      ],
      defaultValue: {},
      buttonArray1: [
        {
          text: "通过",
          key: "review"
        },
        {
          text: "拒绝",
          key: "reject"
        }
      ],
      buttonArray2: [
        {
          text: "解绑",
          key: "resolve"
        },
        {
          text: "删除",
          key: "remove"
        }
      ],
      buttonArray3: [
        {
          text: "解绑",
          key: "resolve",
          disabled: true
        },
        {
          text: "删除",
          key: "remove"
        }
      ],
      agentList: [],
      pageCount: 0,
      activePage: tmpPage,
      totalElements: 0
    };
  },
  computed: {
    activeSearchArray() {
      if (this.ROLE_AGENT) {
        return this.agentSearchArray;
      } else if (this.ROLE_REGION_MANAGER) {
        return this.regionSearchArray;
      } else if (this.ROLE_SUPER_ADMIN) {
        return this.adminSearchArray;
      }
    }
  },
  created() {
    this.loadProvice();
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1
      };
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }

      sessionStorage.setItem("medicalInstitutionAnalysisPage", JSON.stringify(this.activePage));
      sessionStorage.setItem("medicalInstitutionSearchForm", JSON.stringify(this.searchFormData));

      let data;
      if (this.ROLE_AGENT) {
        data = await this.$http.getMedicalEstablishmentList(
          params,
          "ROLE_AGENT"
        );
        if (data) {
          let newTableData = [];
          data.forEach(item => {
            let sweekSalesales = [];
            newTableData.push({
              stationId: item.stationId,
              name: item.name,
              district: item.district ? item.district.name : "",
              location: item.location,
              authState: MapAgentStationStatus(item.authState),
              agentName: item.agentName,
              companyName: item.companyName,
              createdBy: "",
              id: item.stationUUID,
              remainingTreatmentCount: item.remainingTreatmentCount,
              agentStationState: item.reviewState,
              sweekSalesales: sweekSalesales,
              patientShow: item.patientShow,
              presellFlag: item.presellFlag,
              singleSaleCount: item.singleSaleCount
            });
          });
          this.tableData = newTableData;
          this.totalElements = data.length;
        }
      } else if (this.ROLE_SUPER_ADMIN) {
        data = await this.$http.getMedicalEstablishmentList(
          params,
          "ROLE_SUPER_ADMIN"
        );
        if (data && data.content) {
          this.pageCount = data.totalPages;
          this.totalElements = data.totalElements;
          let newTableData = [];
          data.content.forEach(item => {
            let sweekSalesales = [];
            if (item.weekSales && item.weekSales.length > 0) {
              item.weekSales.forEach((o, index) => {
                if (index + 1 === item.weekSales.length) {
                  sweekSalesales.push(`${o.count} (今日)`);
                } else {
                  sweekSalesales.push(`${o.count}`);
                }
              });
            }
            newTableData.push({
              stationId: item.stationId,
              name: item.name,
              district: item.district ? item.district.name : "",
              location: item.location,
              authState: MapAgentStationStatus(item.authState),
              agentName: item.agentName,
              companyName: item.companyName,
              createdBy: item.createdBy,
              id: item.stationUUID,
              remainingTreatmentCount: item.remainingTreatmentCount,
              reviewState: item.reviewState,
              sweekSalesales: sweekSalesales,
              singleSaleCount: item.singleSaleCount
            });
          });
          this.tableData = newTableData;
        }
      } else if (this.ROLE_REGION_MANAGER) {
        data = await this.$http.getMedicalEstablishmentList(
          params,
          "ROLE_REGION_MANAGER"
        );
        if (data && data.content) {
          this.pageCount = data.totalPages;
          this.totalElements = data.totalElements;
          let newTableData = [];
          data.content.forEach(item => {
            let sweekSalesales = [];
            if (item.weekSales && item.weekSales.length > 0) {
              item.weekSales.forEach((o, index) => {
                if (index + 1 === item.weekSales.length) {
                  sweekSalesales.push(`${o.count} (今日)`);
                } else {
                  sweekSalesales.push(`${o.count}`);
                }
              });
            }
            newTableData.push({
              stationId: item.stationId,
              name: item.name,
              district: item.district ? item.district.name : "",
              location: item.location,
              authState: MapAgentStationStatus(item.authState),
              agentName: item.agentName,
              companyName: item.companyName,
              createdBy: item.createdBy,
              id: item.stationUUID,
              reviewState: item.reviewState,
              remainingTreatmentCount: item.remainingTreatmentCount,
              sweekSalesales: sweekSalesales,
              singleSaleCount: item.singleSaleCount
            });
          });
          this.tableData = newTableData;
        }
      }
    },
    onSearch(done) {
      this.activePage = 1;
      this.loadData();
    },
    async loadProvice() {
      let ProvinceList = [];
      let province = [];
      if (this.ROLE_AGENT) {
        ProvinceList = await this.$http.getProvinceList("agent");
        province = this.agentSearchArray;
      } else if (this.ROLE_SUPER_ADMIN) {
        ProvinceList = await this.$http.getProvinceList("superAdmin");
        province = this.adminSearchArray;
      } else if (this.ROLE_REGION_MANAGER) {
        ProvinceList = await this.$http.getProvinceList("regionManager");
        province = this.regionSearchArray;
      }
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        province.forEach(o => {
          if (o.keyName === "provinceCity") {
            o.children = provinceChildren;
          }
        });
        this.ProvinceList = provinceChildren;
      }
    },
    onSearchChange(data) {
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    async handleApply(row) {
      const updateData = {
        stationId: row.id
      };
      let result = await this.$http.agentApplyStation(updateData);
      if (result === "success") {
        this.loadData();
      }
    },
    onClick(row) {
      this.$router.push({
        path: `${this.$route.path}/organizationDetail/${row.id}`
      });
    },
    async onAddStation(form) {
      if (this.ROLE_AGENT) {
        const updateData = {
          name: form.name,
          districtId: form.districtCity,
          location: form.location,
          applied: form.duty.indexOf("申请授权") > -1,
          coursePrice: form.coursePrice
        };
        let result = await this.$http.agentAddStation(updateData);
        if (result === "success") {
          this.loadData();
        }
      } else if (this.ROLE_REGION_MANAGER) {
        const updateData = {
          name: form.name,
          districtId: form.districtCity,
          location: form.location,
          agentId: form.agentId,
          stationId: form.stationId,
          coursePrice: form.coursePrice
        };
        let result = await this.$http.regionAddStation(updateData);
        if (result === "success") {
          this.loadData();
        }
      }
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "review":
          this.reviewStation = true;
          break;
        case "reject":
          this.rejectStation = true;
          break;
        case "resolve":
          this.resolveStation = true;
          break;
        case "remove":
          this.removeStation = true;
          break;
      }
    },
    onClickCancel(key) {
      this.defaultValue = {};
      switch (key) {
        case "review":
          this.reviewStation = false;
          break;
        case "reject":
          this.rejectStation = false;
          break;
        case "resolve":
          this.resolveStation = false;
          break;
        case "remove":
          this.removeStation = false;
          break;
        case "distributeAgent":
          this.distribution = false;
          break;
        case "distributionRefund":
          this.distributionRefund = false;
          break;
      }
    },
    async onUpdateAccount(formdata, type, row) {
      if (type === "review") {
        const updateData = {
          stationUUID: row.id,
          reviewedState: "REVIEWED"
        };
        let result = await this.$http.regionOperationStation(
          updateData,
          "review"
        );
      } else if (type === "reject") {
        const updateData = {
          stationUUID: row.id,
          reviewedState: "REFUSED"
        };
        let result = await this.$http.regionOperationStation(
          updateData,
          "reject"
        );
      } else if (type === "resolve") {
        const updateData = {
          stationUUID: row.id
          // agentId: row.agentName
        };
        let result = await this.$http.regionOperationStation(
          updateData,
          "resolve"
        );
      } else if (type === "remove") {
        const updateData = {
          stationUUID: row.id
        };
        let result = await this.$http.regionOperationStation(
          updateData,
          "remove"
        );
      } else if (type === "distributeAgent") {
        const updateData = {
          userId: this.defaultValue.id,
          quantity: formdata.courseCount,
          unitPrice: formdata.unitPrice ,
          distributeType: formdata.distributeType,
          operateType: 'PAY',
          saleFlag: true
        }
        await this.$http.distributeStation(updateData)
        this.distribution = false;
      } else if (type === "distributionRefund") {
        const updateData = {
          userId: this.defaultValue.id,
          quantity: formdata.courseCount,
          unitPrice: formdata.unitPrice,
          distributeType: formdata.distributeType,
          operateType: 'REFUND',
          saleFlag: true
        }
        await this.$http.distributeStation(updateData)
        this.distributionRefund = false;
      }
      this.loadData();
      this.defaultValue = {};
    },
    async regionAddNew() {
      if (this.ROLE_AGENT) {
        this.addingUser = true;
      } else if (this.ROLE_REGION_MANAGER) {
        const agentList = await this.$http.regionGetAgentListforAddStation();
        if (agentList && agentList.content) {
          let temp = [];
          agentList.content.forEach(o => {
            temp.push({
              keyName: o.user.id,
              label: o.companyName,
              districts: o.districts
            });
          });
          this.agentList = temp;
        }
        this.addingStation = true;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    },
    async handlePatientShowChange(id, value) {
      await this.$http.updatePatientShowFlag(id, value);
      this.loadData();
    },
    async handlePresellFlagChange(id, value) {
      await this.$http.updatePresellFlag(id, value);
      this.loadData();
    },
    async onAddSalesPromotions(params, typeName, row) {
      params.stationId = row.id
      await this.$http.saveSalesPromotions(params);
      this.salesPromotionFlag = false;
    }
  }
};
</script>
<template>
  <div class="StationListindex">
    <DialogForm
      v-if="addingUser"
      formTitle="添加医疗机构"
      :formInputArray="addNewStationArr"
      @close="addingUser = false"
      @submitForm="onAddStation"
      keyOperation="addAccount"
      :ProvinceList="ProvinceList"
    />
    <DialogForm
      v-if="addingStation"
      formTitle="添加医疗机构"
      :formInputArray="addNewStationRegion"
      @close="addingStation = false"
      @submitForm="onAddStation"
      keyOperation="addAccount"
      :ProvinceList="ProvinceList"
      :agentList="agentList"
    />
    <DialogForm
      v-if="reviewStation"
      :defaultValue="defaultValue"
      formTitle="请确认通过审核"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="review"
      confirmButton="确认"
    />
    <DialogForm
      v-if="rejectStation"
      :defaultValue="defaultValue"
      formTitle="请确认拒绝通过审核"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="reject"
      confirmButton="确认"
    />
    <DialogForm
      v-if="resolveStation"
      :defaultValue="defaultValue"
      formTitle="请确认解绑医疗机构"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="resolve"
      confirmButton="确认"
    />
    <DialogForm
      v-if="removeStation"
      :defaultValue="defaultValue"
      formTitle="请确认删除医疗结构"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="remove"
      confirmButton="确认"
    />
    <DialogForm
      v-if="distribution"
      formTitle="分销供货"
      :formInputArray="distributeArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="distributeAgent"
      :alertItem="operationGoodsAlert"
    />
    <DialogForm
      v-if="distributionRefund"
      formTitle="分销退货"
      :formInputArray="distributeArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="distributionRefund"
      :alertItem="operationGoodsAlert"
    />
    <DialogForm
      v-if="salesPromotionFlag"
      formTitle="促销申请"
      :formInputArray="addNewReqArr"
      @close="salesPromotionFlag = false"
      @submitForm="onAddSalesPromotions"
      :defaultValue="defaultValue"
      keyOperation="addReq"
    />
    <searchFormNew
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="activeSearchArray"
    />
    <elementButton
      class="addNewButton"
      v-if="ROLE_AGENT || ROLE_REGION_MANAGER"
      @click="regionAddNew"
      size="mini"
      type="primary"
    >添加医疗机构</elementButton>
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      @row-click="onClick"
      class="hospitalTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="name" align="left" label="机构名称" min-width="150"></el-table-column>
      <el-table-column prop="district" align="left" label="所属城市" width="120"></el-table-column>
      <el-table-column
        v-if="ROLE_REGION_MANAGER"
        prop="createdBy"
        align="left"
        label="创建人"
        width="100"
      ></el-table-column>
      <el-table-column prop="companyName" align="left" label="代理商" min-width="130"></el-table-column>
      <el-table-column prop="remainingTreatmentCount" label="可用疗程数" min-width="90"></el-table-column>
      <el-table-column prop="singleSaleCount" label="可用单次训练数" min-width="90"></el-table-column>
      <el-table-column
        v-if="!ROLE_AGENT"
        prop="sweekSalesales"
        align="left"
        label="最近一周销量"
        min-width="200"
      >
        <template slot-scope="scope">
          <span class="weeklySale">
            <span
              v-for="(item, index) in scope.row.sweekSalesales"
              :key="index+scope.row.id"
            >{{item}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="ROLE_REGION_MANAGER"
        prop="reviewState"
        align="left"
        label="状态"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.reviewState === 'PENDING'">
            <span class="pedingIcon"></span> 审核中
          </span>
          <span v-else-if="scope.row.reviewState === 'REVIEWED'">
            <span class="passIcon"></span>
            已核准
          </span>
          <span v-else-if="scope.row.reviewState === 'REFUSED'">
            <span class="refuseIcon"></span>
            已拒绝
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="ROLE_AGENT" prop="operation" width="140" align="left" label="授权">
        <template slot-scope="scope">
          <span v-if="scope.row.authState === '审核中'">
            <span class="pedingIcon"></span> 审核中
          </span>
          <span v-else-if="scope.row.authState === '已核准'">
            <span class="passIcon"></span> 已核准
          </span>
          <span v-else-if="scope.row.authState === '已拒绝'">
            <span class="refuseIcon"></span> 已拒绝
          </span>
          <span v-else @click.stop>
            <elementButton size="mini" @click="handleApply(scope.row)">申请授权</elementButton>
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="ROLE_AGENT" prop="operation" width="95" align="left" label="患者保密">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.patientShow" 
            :active-value="false"
            :inactive-value="true"
            @click.native.stop="return false"
            @change = "handlePatientShowChange(scope.row.id, scope.row.patientShow)" />
        </template>
      </el-table-column>
      <el-table-column v-if="ROLE_AGENT" prop="presellFlag" width="95" align="left" label="允许预售">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.presellFlag" 
            :active-value="true"
            :inactive-value="false"
            @click.native.stop="return false"
            @change = "handlePresellFlagChange(scope.row.id, scope.row.presellFlag)" />
        </template>
      </el-table-column>
      <el-table-column
        v-if="ROLE_REGION_MANAGER"
        prop="operation"
        align="left"
        label="操作"
        width="140"
      >
        <template slot-scope="scope">
          <span @click.stop>
            <textButtonGroup
              v-if="scope.row.reviewState === 'PENDING'"
              :buttonArray="buttonArray1"
              :rowData="scope.row"
              @onOperationClick="onOperationClick"
            />
            <textButtonGroup
              v-else
              :buttonArray="scope.row.agentName ? buttonArray2 : buttonArray3"
              :rowData="scope.row"
              @onOperationClick="onOperationClick"
            />
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="ROLE_AGENT"
        prop="operation"
        align="left"
        min-width="290"
        label="操作"
      >
      <template slot-scope="scope">
        <span class="textButton">
          <el-button type="text" size="small" @click.stop="distribution = true; defaultValue = scope.row">供货</el-button>
          <el-button type="text" size="small" @click.stop="distributionRefund = true; defaultValue = scope.row">退货</el-button>
          <el-button type="text" size="small" @click.stop="salesPromotionFlag = true; defaultValue = scope.row">促销申请</el-button>
        </span>
      </template>
    </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.StationListindex {
  .searchForm {
    padding-top: 15px;
    border: 1px;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .addNewButton {
    width: 110px;
    border: 1px;
    margin-left: 2%;
    margin-top: 5px;
    margin-bottom: 10px;
    font-size: 14px;
    border-radius: 3px;
    float: left;
    padding: 10px;
  }
  .pedingIcon {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: yellowgreen;
    display: inline-block;
  }
  .passIcon {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #13ce66;
    display: inline-block;
  }
  .refuseIcon {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: red;
    display: inline-block;
  }

  .hospitalTable {
    margin: 30px 2%;
    border: 1px;
    width: 96%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    .weeklySale {
      display: flex;
      justify-content: space-around;
    }
    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/medicalEstablishment/index.vue